/**
 * @format
 * @Description: 产品列表状态机
 * @Autho: 人杰
 * @Date: 2019/10/19:2019/10/18 11:47
 */

import { action, observable, useStrict } from 'mobx';

const CDN_BASE = 'assets';
useStrict(true);
class ProductDetailMod {
  @observable
  loading = true;

  @action updateLoading() {
    this.loading = !this.loading;
  }
}

// ES6单例写法
export default new ProductDetailMod();



// WEBPACK FOOTER //
// ./src/pages/ProductDetail/ProductDetailMod.js